import { ChevronLeft, ChevronRight, Download, X } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { useI18n } from '../i18n/I18nProvider';
import { useModalFocus } from './useModalFocus';
import { CatalogAssetImage } from './CatalogAssetImage';

export function ImageLightbox({ images, index, alt, onIndex, onClose, onDownload }: {
  images: string[]; index: number; alt: string; onIndex: (index: number) => void; onClose: () => void; onDownload?: () => void;
}) {
  const { t } = useI18n();
  const root = useRef<HTMLDivElement>(null);
  useModalFocus(true, root, onClose);
  const multiple = images.length > 1;
  const previous = () => onIndex((index - 1 + images.length) % images.length);
  const next = () => onIndex((index + 1) % images.length);
  useEffect(() => {
    const prior = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const keydown = (event: KeyboardEvent) => {
      if (event.key === 'ArrowLeft' && multiple) onIndex((index - 1 + images.length) % images.length);
      if (event.key === 'ArrowRight' && multiple) onIndex((index + 1) % images.length);
    };
    window.addEventListener('keydown', keydown);
    return () => { document.body.style.overflow = prior; window.removeEventListener('keydown', keydown); };
  }, [images.length, index, multiple, onClose, onIndex]);
  return <div ref={root} className="image-lightbox" role="dialog" aria-modal="true" aria-label={t('common.imagePreview')}>
    <button tabIndex={-1} className="image-lightbox__scrim" onClick={onClose} aria-label={t('common.closePreview')} />
    <div className="image-lightbox__frame">
      <div className="image-lightbox__toolbar"><span>{index + 1} / {images.length}</span>{onDownload && <button className="icon-button" onClick={onDownload} aria-label={t('admin.downloadClean')}><Download /></button>}<button data-modal-close className="icon-button" onClick={onClose} aria-label={t('common.closePreview')}><X /></button></div>
      <CatalogAssetImage src={images[index]} alt={`${alt} ${index + 1}`} />
      {multiple && <><button className="icon-button image-lightbox__previous" onClick={previous} aria-label={t('common.previousImage')}><ChevronLeft /></button><button className="icon-button image-lightbox__next" onClick={next} aria-label={t('common.nextImage')}><ChevronRight /></button></>}
    </div>
  </div>;
}
